import styled from 'styled-components'

export const ModalDialog = styled.div`
  position: ${props => props.visible ? 'fixed' : 'static'};
  float: left;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: ${props => props.visible ? 1073 : -100};
  display: flex;
  flex-direction: column;
  overflow: auto;
  width: 100vw;
  height: 100vh;
  background-color: var(--the-white);
  transition: all 0.05s ease-in;
  opacity: ${props => props.visible ? 1 : 0};
  display: ${props => props.visible ? 'block' : 'none'};
  border-radius: 2.4rem;
  padding: 24px;
  gap: 16px;
  ${props => props.modalHeight ? `height:${props.modalHeight};` : 'fit-content'}
`

export const ModalBackdrop = styled.span`
  display: ${props => props.visible ? 'flex' : 'none'};
  align-items:center;
  justify-content:center;
  content: '';
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1072;
`
